export default "__VITE_ASSET__Cn3Ox4Ci__"